import type { SvgIconComponent } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

type FeatureCardProps = {
  icon: SvgIconComponent;
  title: string;
  description: string;
};

export default function FeatureCard({
  icon: Icon,
  title,
  description,
}: FeatureCardProps) {
  return (
    <Box className="flex-1 flex flex-col items-center text-center">
      <Icon className="text-featured text-28 mb-8" />
      <Typography className="font-600 text-14 text-typography-primary mb-4">
        {title}
      </Typography>
      <Typography className="text-12 text-typography-secondary leading-[18px]">
        {description}
      </Typography>
    </Box>
  );
}
